<template>

    <ThemeChanger>

        <PageHeader class="pt-32 lg:pt-48" :header="cms.page_header_heading" :sub-header="cms.page_header_content" :header-span="5"/>

        <Container fluid class="mt-48 space-y-24">

            <Grid v-for="(blog, index) of loadedItems" :key="index">

                <AOS type="fade-up" easing="ease" :duration="500" :delay="index * 400">

                    <Column :span="[ 2, 4 ]" :push="[ 0, 1 ]">

                        <Anchor :route="{ name: Route.BlogPost, params: { slug: blog.slug } }">

                            <Heading tag="h2" no-margin v-html="blog.title"/>

                        </Anchor>

                        <Paragraph class="pt-2">
                            {{ blog.updated_at }} · Written by {{ blog.author.name }}
                        </Paragraph>

                    </Column>

                    <Column v-if="blog.cover" :span="[ 2, 6 ]" :push="[ 0, 0 ]" class="mt-12">

                        <Anchor :route="{ name: Route.BlogPost, params: { slug: blog.slug } }">

                            <Picture :image="blog.cover" auto/>

                        </Anchor>

                    </Column>

                    <Column :span="[ 2, 4 ]" :push="[ 0, 1 ]" class="mt-24">

                        <Paragraph v-html="blog.introduction"/>

                    </Column>

                </AOS>

            </Grid>

        </Container>

    </ThemeChanger>

    <MetaInfo v-if="cms.seo" :seo="cms.seo" :structured-data="cms.seo_structured_data"/>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'
    import Container from '../components/Container.vue'
    import Column from '../components/Grid/Column.vue'
    import Grid from '../components/Grid/Grid.vue'
    import Anchor from '../components/Anchor.vue'
    import PageHeader from '../components/PageHeader.vue'
    import Picture from '../components/Picture.vue'
    import Heading from '../components/Heading.vue'
    import MetaInfo from '../components/MetaInfo.vue'
    import Paragraph from '../components/Paragraph.vue'
    import ThemeChanger from '../components/ThemeChanger.vue'
    import { Route } from '../enums/Route'
    import { useCms } from '../compositions/UseCms'
    import { useTheme } from '../compositions/UseTheme'
    import { useFakeLazyLoad } from '../compositions/behaviors/UseFakeLazyLoad'

    export default defineComponent({
        name: 'Blog',
        components: {
            Container,
            Column,
            Grid,
            Anchor,
            PageHeader,
            Picture,
            Heading,
            Paragraph,
            MetaInfo,
            ThemeChanger
        },
        setup() {

            useTheme().initializeCurrentThemeBasedOnRouteMeta()

            const { blog, blogs } = useCms()
            const { loadedItems } = useFakeLazyLoad(blogs.value)

            return {
                Route,
                cms: blog,
                blogs,
                loadedItems
            }

        }
    })

</script>
